import { SelectMenuItem } from 'bold-ui'
import { SelectDownshiftMenuProps } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import React, { Fragment } from 'react'

import { AtividadeColetivaGrupoSelectFieldCabecalho } from './AtividadeColetivaGrupoSelectFieldCabecalho'
import { AtividadeColetivaGrupoSelectFieldItem } from './AtividadeColetivaGrupoSelectFieldItem'
import { AtividadeColetivaGrupoSelectFieldVazio } from './AtividadeColetivaGrupoSelectFieldVazio'
import { AtividadeColetivaGrupoSelectItemModel } from './model-atividadeColetivaGrupoSelectField'
import {
  isAtividadeColetivaGrupoItemModel,
  isTipoGrupoCabecalho,
  isTipoGrupoVazio,
} from './typeGuard-atividadeColetivaGrupoSelect'

export interface AtividadeColetivaGrupoSelectItemProps
  extends SelectDownshiftMenuProps<AtividadeColetivaGrupoSelectItemModel> {
  item: AtividadeColetivaGrupoSelectItemModel
}

export function AtividadeColetivaGrupoSelectItem(props: Readonly<AtividadeColetivaGrupoSelectItemProps>) {
  const {
    downshift: { getItemProps },
    item,
  } = props

  return (
    <Fragment>
      {isTipoGrupoCabecalho(item) && <AtividadeColetivaGrupoSelectFieldCabecalho tipoCabecalho={item} />}
      {isTipoGrupoVazio(item) && <AtividadeColetivaGrupoSelectFieldVazio />}
      {isAtividadeColetivaGrupoItemModel(item) && (
        <SelectMenuItem {...getItemProps({ item })}>
          <AtividadeColetivaGrupoSelectFieldItem item={item} />
        </SelectMenuItem>
      )}
    </Fragment>
  )
}
